(function($) {
  console.log("Zoominfo script load check in progress");
  setTimeout(formCheckInitialize, 2500);
  function formCheckInitialize() {
    if (jQuery(".mktoForm").length > 0) {
      console.log("Marketo form found on page");
      marketoFallback();
    } else if (jQuery(".webform-submission-form").length > 0) {
      console.log("Webform found on page");
      webformFallback();
    }
  }
  function marketoFallback() {
    if (jQuery(".mktoForm[data-zi-mapped-form]").length > 0) {
      console.log("Marketo Zoominfo script load check complete: ZI loaded");
      $(".mktoForm").attr("zi-load-success", "true");
      $(".mktoForm").attr(
        "data-initial-wrapper-tagging-complete",
        "true"
      );
    } else if (jQuery(".mktoForm[data-zi-mapped-form]").length === 0) {
      console.log(
        "Marketo Zoominfo script load check complete: ZI not loaded"
      );
      $(".mktoForm").attr("zi-load-failed", "true");
      $(".mktoForm").attr(
        "data-initial-wrapper-tagging-complete",
        "true"
      );
    }
  }
  function webformFallback() {
    if (
      jQuery(".webform-submission-form[data-zi-mapped-form]").length > 0
    ) {
      console.log("Webform Zoominfo script load check complete: ZI loaded");
      $(".webform-submission-form").attr("zi-load-success", "true");
      $(".webform-submission-form").attr(
        "data-initial-wrapper-tagging-complete",
        "true"
      );
    } else if (
      jQuery(".webform-submission-form[data-zi-mapped-form]").length === 0
    ) {
      console.log("Webform Zoominfo script load check complete: ZI not loaded");
      $(".webform-submission-form").attr("zi-load-failed", "true");
      $(".webform-submission-form").attr(
        "data-initial-wrapper-tagging-complete",
        "true"
      );
    }
  }
})(jQuery);
